import React from "react";
import { Box, useTheme, Text, Stack } from "@bookingcom/bui-react";
import { useI18n } from "@bookingcom/lingojs-react";
import { t } from "@bookingcom/lingojs-core";
import * as etV2 from "@flights/et-universal";
import { SearchboxController, SearchBoxHorizontalDefault } from "@bookingcom/flights-searchbox";

import Container from "../Container";
import NoJS from "screens/NoJS";
import useSearchbox from "hooks/useSearchbox";
import useLocaleContext from "hooks/useLocaleContext";
import useLandingPageEvents from "hooks/c360/useLandingPageEvents";

import styles from "./HomeSearchHeader.desktop.module.css";
import { BLACK_FRIDAY_BG_COLOR } from "../../../constants";

const offset = 54; // Half the searcharea height
const offsetAddition = 14;

const HomeSearchHeader = () => {
  const theme = useTheme();
  const i18n = useI18n();
  const searchBoxProps = useSearchbox();
  const { isRTL } = useLocaleContext();
  const trackLandingPageEvents = useLandingPageEvents();

  return (
    <>
      <Box
        className={styles.box}
        attributes={{
          style: {
            backgroundColor: `${BLACK_FRIDAY_BG_COLOR}`,
            padding: 0
          }
        }}
      >
        <Container className={styles.container}>
          <NoJS />
          <Stack
            gap={1}
            direction="row"
            justifyContent="start"
            attributes={{ style: { paddingBottom: offset + offsetAddition + 5 } }}
          >
            <Stack.Item grow attributes={{ style: { maxWidth: "600px" } }}>
              <Text variant="display_3" data-testid="home_header" tagName="h1" color="white" className={styles.title}>
                {i18n.trans(t("flights_cat_summer_deal_index_header"))}
              </Text>
              <Text variant="featured_2" color="white" className={styles.subtitle}>
                {i18n.trans(t("flights_cat_summer_deal_index_subheader"))}
              </Text>
            </Stack.Item>
          </Stack>
        </Container>
      </Box>

      <Box
        attributes={{
          style: {
            width: "100%",
            paddingTop: 0
          }
        }}
      >
        <Container
          style={{
            padding: 0,
            transform: `translateY(calc(-${offset + offsetAddition}px - ${theme.units.spacing_3x}))`,
            marginBottom: -offset
          }}
        >
          <SearchboxController
            i18n={i18n}
            {...searchBoxProps}
            hideShadow={true}
            isRTL={isRTL}
            isHeaderUpdateExp={true}
            onSearch={(searchParams) => {
              trackLandingPageEvents("click", "searchbox");
              etV2.customGoal("mvsf_whs_launchpad_stays_flights_www", 2);
              searchBoxProps.onSearch(searchParams);
            }}
          >
            {SearchBoxHorizontalDefault}
          </SearchboxController>
        </Container>
      </Box>
    </>
  );
};

export default HomeSearchHeader;
